<template>
  <v-toolbar app scroll-off-screen flat
  color="#FFD052"
  light
  >
    <v-toolbar-title class="font-weight-light ml-0">
      <a href="/#/" class="body-1 no-a hidden-sm-and-up"><b>Дети</b></a>
      <a href="/#/" class="no-a hidden-xs-only"><b>Дети</b></a>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items v-if="profile">
      <v-btn href="/#/transfers" flat
      :class="'navlink mx-0 hidden-sm-and-down' + (cur === 'transfers' ? ' navlink-active' : '')"
      >
        транзакции
      </v-btn>
      <v-btn href="/#/messages" flat
      :class="'navlink mx-0 hidden-sm-and-down' + (cur === 'messages' ? ' navlink-active' : '')"
      >
        сообщения
      </v-btn>
      <v-btn href="/#/statements" flat
      :class="'navlink mx-0 hidden-sm-and-down' + (cur === 'statements' ? ' navlink-active' : '')"
      >
        заявления
      </v-btn>
      <v-btn href="/#/events" flat
      :class="'navlink mx-0 hidden-sm-and-down' + (cur === 'events' ? ' navlink-active' : '')"
      >
        проходы
      </v-btn>
      <v-btn href="/#/settings" flat
      :class="'navlink mx-0 hidden-sm-and-down' + (cur === 'settings' ? ' navlink-active' : '')"
      >
        настройки
      </v-btn>
    </v-toolbar-items>
    <v-toolbar-items>
      <v-menu offset-y bottom class="hidden-sm-and-down">
        <v-btn slot="activator" flat
        :class="'navlink mx-0' + (['pay', 'sms'].includes(cur) ? ' navlink-active' : '')"
        >О сервисе</v-btn>
        <v-list>
          <v-list-tile href="/#/pay">
            <v-list-tile-title>Пополнение счёта</v-list-tile-title>
          </v-list-tile>
          <v-list-tile href="/#/sms" v-if="false">
            <v-list-tile-title>СМС-команды</v-list-tile-title>
          </v-list-tile>
          <v-list-tile href="/#/">
            <v-list-tile-title>Вопрос-ответ</v-list-tile-title>
          </v-list-tile>
          <v-list-tile href="/#/additionalservices">
            <v-list-tile-title>Дополнительные услуги</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <user-bar v-if="profile" class="navlink mx-0"></user-bar>
      <template v-else-if="connected">
        <v-btn class="navlink mx-0" flat href="/#/login"><span>Вход</span></v-btn>
        <v-btn class="navlink mx-0 hidden-xs-only" flat href="/#/signup"><span>Регистрация</span></v-btn>
      </template>
      <site-notifications v-if="profile"></site-notifications>
      <v-btn v-if="profile" flat icon href="/#/support">
        <v-icon>contact_support</v-icon>
      </v-btn>
      <v-menu offset-y bottom left>
        <v-btn icon class="hidden-md-and-up" slot="activator">
          <v-icon>menu</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile href="/#/pay">
            <v-list-tile-title>Пополнение счёта</v-list-tile-title>
          </v-list-tile>
          <v-list-tile href="/#/sms" v-if="false">
            <v-list-tile-title>СМС-команды</v-list-tile-title>
          </v-list-tile>
          <v-list-tile href="/#/">
            <v-list-tile-title>Вопрос-ответ</v-list-tile-title>
          </v-list-tile>
          <v-list-tile href="/#/additionalservices">
            <v-list-tile-title>Дополнительные услуги</v-list-tile-title>
          </v-list-tile>
          <v-divider v-if="profile"></v-divider>
          <v-list-tile href="/#/transfers" v-if="profile">
            <v-list-tile-title>Транзакции</v-list-tile-title>
          </v-list-tile>
          <v-list-tile href="/#/messages" v-if="profile">
            <v-list-tile-title>Сообщения</v-list-tile-title>
          </v-list-tile>
          <v-list-tile href="/#/statements" v-if="profile">
            <v-list-tile-title>Заявления</v-list-tile-title>
          </v-list-tile>
          <v-list-tile href="/#/events" v-if="profile">
            <v-list-tile-title>Проходы</v-list-tile-title>
          </v-list-tile>
          <v-list-tile href="/#/settings" v-if="profile">
            <v-list-tile-title>Настройки</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <slot name="addon"></slot>
    </v-toolbar-items>
  </v-toolbar>
</template>
<script>
import UserBar from '@/components/UserBar'
import SiteNotifications from '@/components/SiteNotifications'
export default {
  name: 'site-toolbar',
  data: () => ({
    variants: [
      '#80DAEB',
      '#7DF9FF',
      '#E0FFFF',
      '#C7FCEC',
      '#FFBA00',
      '#87CEEB',
      '#F0FFFF',
      '#F5FFFA',
      '#AAF0D1',
      '#08E8DE',
      '#F0FFF0',
      '#98FB98',
      '#78DBE2',
      '#30BA8F',
      '#FFF8E7',
      '#AAF0D1'
    ],
    cindex: 0
  }),
  props: [ 'dark' ],
  components: {
    UserBar, SiteNotifications
  },
  methods: {
    toggleColor () {
      this.cindex++
      if (this.cindex === this.variants.length) this.cindex = 0
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    connected () {
      return this.$store.state.connected
    },
    cur () {
      const cur = this.$store.state.currentRoute
      return cur ? cur.name : '?'
    },
    tbcol () {
      return this.variants[this.cindex]
    }
  }
}
</script>

<style lang="css">

#top {
  border-bottom: 1px solid #080808 !important;
}
.no-a {
  text-decoration: none;
  color: inherit;
}
.navlink {
  font-weight: 400;
  -font-weight: 300;
}
.navlink-active {
  background-color:rgba(255,255,255,.3);
}
</style>
